import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ReferenceBookPartnersProductCatalog = lazy(() => import("@/pages/ReferenceBooks/Lists/ProductCatalogs/ReferenceBookPartnersProductCatalog"));
const ReferenceBookClientsProductCatalog = lazy(() => import("@/pages/ReferenceBooks/Lists/ProductCatalogs/ReferenceBookClientsProductCatalog"));

const urlsConfig = new UrlsConfig();

export function referenceBookProductCatalogsRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookPartnersProductCatalog.to}
                 element={<ReferenceBookPartnersProductCatalog/>}/>
          <Route path={urlsConfig.referenceBookClientsProductCatalog.to}
                 element={<ReferenceBookClientsProductCatalog/>}/>
      </>
    );
}
